import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Chip from 'tio-ui/components/chip';
import { htmlSafe } from '@ember/template';
import type { TasProgramTemplateExtension as TasProgramTemplate } from 'tio-data/data/resources/tas-program-template.ext';

export interface BenefitCardSignature {
  Args: {
    template: TasProgramTemplate;
    isEnrolled?: boolean;
  };
  Element: HTMLDivElement;
}

export default class BenefitCard extends Component<BenefitCardSignature> {
  get isDirectPayProgram() {
    return this.args.template.isDirectPayProgram;
  }

  <template>
    <div
      class="tio-bg-surface border border-gray-300/50 rounded-lg p-4 tio-col-extra-loose hover:shadow-md transition-shadow"
      ...attributes
    >
      {{! Chips area - ENROLLED and COURSECA$H chips }}
      <div class="tio-flex-end gap-2 min-h-5">
        {{#if @isEnrolled}}
          <Chip @appearance="faded" @intent="success" @size="sm">
            {{t "tas.dashboard.chips.enrolled"}}
          </Chip>
        {{/if}}
        {{#if this.isDirectPayProgram}}
          <Chip @appearance="faded" @intent="primary" @size="sm">
            {{htmlSafe (t "common.tas.course_cash.default")}}
          </Chip>
        {{/if}}
      </div>

      {{! Content }}
      <div class="tio-col-flush gap-1.5">
        <h3 class="tio-text-base-semibold tio-fg-primary">
          {{@template.programName}}
        </h3>
        {{#if @template.programDescription}}
          <p class="text-sm tio-fg-muted line-clamp-2">
            {{@template.programDescription}}
          </p>
        {{/if}}
      </div>

      {{! Link }}
      <div>
        <LinkTo
          @route="authenticated.tas.getting-started"
          @model={{@template.id}}
          class="tio-text-base-medium tio-fg-primary underline hover:tio-fg-info"
        >
          {{t "tas.dashboard.see_more"}}
        </LinkTo>
      </div>
    </div>
  </template>
}
